import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, ArrowUpRight } from "lucide-react";

const links = [
  { id: "services", label: "Services", type: "anchor" },
  { id: "blanks", label: "Catalogue", type: "anchor" },
  { id: "workwear", label: "Workwear", type: "anchor" },
  { id: "portfolio", label: "Portfolio", type: "anchor" },
  { id: "faq", label: "FAQ", type: "anchor" },
  { id: "sportswear", label: "Sportswear", type: "route", to: "/sportswear" },
  { id: "contact", label: "Contact", type: "anchor" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const renderLink = (l, extraClass = "", onClick) => {
    const cls = `font-heading uppercase text-sm tracking-wider hover:text-[#FF0055] transition-colors ${extraClass}`;
    if (l.type === "route") {
      return (
        <Link
          key={l.id}
          to={l.to}
          data-testid={`nav-link-${l.id}`}
          className={`${cls} inline-flex items-center gap-1`}
          onClick={onClick}
        >
          {l.label}
          <ArrowUpRight size={12} strokeWidth={3} />
        </Link>
      );
    }
    return (
      <a
        key={l.id}
        href={`#${l.id}`}
        data-testid={`nav-link-${l.id}`}
        className={cls}
        onClick={onClick}
      >
        {l.label}
      </a>
    );
  };

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-white border-b-4 border-black"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-10 py-4">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2 font-heading text-2xl md:text-3xl"
        >
          <span className="inline-block w-3 h-3 bg-[#FF0055] nb-border-2" />
          <span className="inline-block w-3 h-3 bg-[#FFE600] nb-border-2" />
          <span className="inline-block w-3 h-3 bg-[#00F0FF] nb-border-2" />
          <span className="ml-1 tracking-tight">CUSTOMADE</span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => renderLink(l))}
        </nav>

        <a
          href="tel:8169272803"
          data-testid="nav-call-cta"
          className="hidden md:inline-flex nb-btn nb-btn-magenta"
        >
          <Phone size={16} strokeWidth={3} />
          Call Now
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((s) => !s)}
          className="md:hidden nb-border-2 p-2 bg-[#FFE600]"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t-4 border-black bg-white">
          <div className="flex flex-col px-5 py-4 gap-3">
            {links.map((l) => renderLink(l, "text-base py-2", () => setOpen(false)))}
            <a
              href="tel:8169272803"
              className="nb-btn nb-btn-magenta self-start"
              data-testid="mobile-call-cta"
            >
              <Phone size={16} strokeWidth={3} /> Call 8169272803
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
